export default function style(theme) {
  return {
    title: {
      marginTop: "2rem",
      textAlign: "left",
      color: theme.palette.text.primary,
    },

    description: {
      margin: "0rem",
      fontSize: "1rem",
      textAlign: "left",
      color: theme.palette.text.tertiary,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },

    link: {
      color: theme.palette.text.highlight,
      marginTop: 10,
      cursor: "pointer",
      width: "fit-content",
      display: "flex",
    },

    wrapper: {
      marginTop: 40,
      marginBottom: 80,
      display: "flex",
      gap: 80,
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
  
    subHeading: {
      display: "block",
      color: theme.palette.text.primary,
    },

    rightContainer: {
      display: "flex",
      flexDirection: "column",
      gap: 20,
    },

    card: {
      height: "fit-content",
      backgroundColor: theme.palette.primary.main,
    },

    media: {
      width: "100%",
      height: "auto",
      borderRadius: 4,
      marginBottom: "3%",
      background: "url(https://cdn.dribbble.com/users/347174/screenshots/2958807/charlie-loader.gif) center center no-repeat, height: 100%, width: 100%",
    },

    nextContainer: {
      textAlign: "center",
      marginBottom: 120,
    },

    arrow: {
      padding: 3,
      fontSize: 27,
      transition: "0.6s",
      color: theme.palette.text.highlight,
    },

    linkhover: {
      color: theme.palette.text.primary,
      fontWeight:"300",
      textDecoration: "none",
      padding: "8px 0px",
      display: "inline-block",
      position: "relative",
      borderBottom: "1px solid #434f66",
      lineHeight: "20px",
      display: 'flex',
      gap:'10px',
      alignItems:'center',
      justifyContent:'center',
      "&::after":{
        content: '""',
        position: "absolute",
        width: "100%",
        transform: "scaleX(0)",
        height: "0.5px",
        bottom: "-0.5px",
        left: "0px",
        zIndex: "2",
        backgroundColor: theme.palette.text.primary,
        transformOrigin: "bottom right",
        transition: "transform 0.4s cubic-bezier(0.86, 0, 0.07, 1)",
      },
      "&:hover::after":{
        transform: "scaleX(1)",
        transformOrigin: "bottom left",
      }
    },

    linkContainer: {
      display: "flex",
      gap: 30,
    },

    embed:{
      width:"100%",
      height:"50vw",
      marginBottom: 40,
      backgroundColor: "transparent",
      // position: "absolute",
      // pointerEvents:"auto",
      // cursor:"pointer",
    },
  };
}
